// * GET =====================================
// Static file next to the bundle, written by the deploy (WAP-1816); served no-store.
export const BUILD_STAMP_GET = `assets/build.json`;
